import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { StripeBuyButton } from './StripeBuyButton';
import { included, site } from '../data/site';
export function Register() {
  return <section id="register" className="bg-cream py-24 sm:py-28" data-id="element-91" data-mp="3tw724fnevk50">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-92" data-mp="3tyt9ofaaxzn8">
        <p className="text-xs uppercase tracking-widest2 text-forest/60" data-id="element-93" data-mp="2r6xfy9ioour">
          Buy your ticket
        </p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-forest sm:text-4xl" data-id="element-94" data-mp="7oyypiw1xnbm">
          Space is limited to {site.seats} attendees.
        </h2>
        <p className="mt-4 text-forest/70" data-id="element-95" data-mp="hgl777h098ao">
          {site.date} · {site.location}
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-forest/15 bg-white text-left" data-id="element-96" data-mp="lflpmovkm8x5">
          <div className="flex items-end justify-between gap-4 border-b border-forest/10 px-8 py-7" data-id="element-97" data-mp="qhb4ygptt8r1">
            <div data-id="element-98" data-mp="vfkxejk61v8y">
              <p className="text-xs uppercase tracking-widest2 text-forest/60" data-id="element-99" data-mp="vcyqmm53njrs">
                Ticket price
              </p>
              <p className="mt-2 font-display text-4xl font-semibold text-forest" data-id="element-100" data-mp="1qbggac6qx46p">
                {site.price}
              </p>
            </div>
            <p className="pb-1 text-xs uppercase tracking-widest2 text-forest/50" data-id="element-101" data-mp="1mao3xa2kuj67">
              Per person
            </p>
          </div>

          <ul className="grid gap-3 px-8 py-7 sm:grid-cols-2" data-id="element-102" data-mp="1hd4mk1al1qa1">
            {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-forest/75" data-id="element-103" data-mp="29zfobf9xdx8f">
                <CheckIcon size={16} className="mt-0.5 shrink-0 text-forest" aria-hidden="true" data-id="element-104" data-mp="257pagzbs4rc9" />
                {item}
              </li>)}
          </ul>

          <div className="border-t border-forest/10 bg-forest/[0.03] px-8 py-7" data-id="element-105" data-mp="2xr4mhc9fhfxa">
            <StripeBuyButton buyButtonId={site.stripe.buyButtonId} publishableKey={site.stripe.publishableKey} data-id="element-106" data-mp="2swqor37amwpg" />
            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-forest/50" data-id="element-107" data-mp="3gtdex218vqks">
              <LockIcon size={13} aria-hidden="true" data-id="element-108" data-mp="332i3bhzd2vdi" />
              Secure checkout powered by Stripe
            </p>
          </div>
        </div>
      </div>
    </section>;
}